module.exports = __webpack_public_path__ + "media/icons/check-circle-pink-6559436e.svg";